import { ComponentHeader, StyledCreate } from "@components";

import { GenerateCdicCouponForm } from "@modules";
import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

export const PageGenerateCdicCoupon = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(setLoading(true));
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 1000);
  }, []);

  return (
    <>
      <ComponentHeader title={t("page.generate_cdic_coupon")} />
      <StyledCreate>
        <GenerateCdicCouponForm />
      </StyledCreate>
    </>
  );
};
